var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.184,
    height: 18.726,
    viewBox: "0 0 15.184 18.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M21.769,18.005c-.732-.964-2.171-1.53-2.171-5.847,0-4.432-1.957-6.213-3.781-6.641-.171-.043-.295-.1-.295-.28V5.1a1.165,1.165,0,0,0-1.14-1.169h-.028A1.165,1.165,0,0,0,13.214,5.1v.138c0,.176-.124.238-.295.28-1.829.432-3.781,2.209-3.781,6.641,0,4.318-1.439,4.878-2.171,5.847a.943.943,0,0,0,.755,1.511H21.028A.944.944,0,0,0,21.769,18.005Zm-1.853.276H8.839a.208.208,0,0,1-.157-.347,5.755,5.755,0,0,0,1-1.587,10.765,10.765,0,0,0,.679-4.19,7.285,7.285,0,0,1,.993-4.123A3.048,3.048,0,0,1,13.19,6.724a1.665,1.665,0,0,0,.884-.5.376.376,0,0,1,.565-.009,1.721,1.721,0,0,0,.893.508A3.048,3.048,0,0,1,17.37,8.035a7.285,7.285,0,0,1,.993,4.123,10.765,10.765,0,0,0,.679,4.19,5.82,5.82,0,0,0,1.021,1.61A.2.2,0,0,1,19.916,18.281Z",
    transform: "translate(-6.775 -3.93)",
    fill: "#777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20013",
    "data-name": "Path 20013",
    d: "M0,0S1.917,1.735,3.743,1.735A6.087,6.087,0,0,0,7.3,0",
    transform: "translate(3.789 16.492)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a724d57aa7deb91d886ee89399bfaadb.svg";
export { ForwardRef as ReactComponent };